import React, { useState } from 'react';
import { AiOutlineBars, AiOutlineArrowLeft } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../ThemeContext';

const Navbar = ({ activeTab, setActiveTab }) => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark'; // Check if theme is dark
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleMenuToggle = () => setIsMobileMenuOpen((prev) => !prev);

  const getButtonClasses = (tab) => {
    const baseClasses =
      'px-4 py-2 rounded-lg transition-all duration-300 ease-in-out text-sm lg:text-base';
    if (activeTab === tab) {
      return `${baseClasses} ${
        isDarkMode ? 'bg-gray-700 text-white' : 'bg-blue-500 text-white'
      }`;
    } else {
      return `${baseClasses} ${
        isDarkMode
          ? 'text-white hover:bg-gray-600'
          : 'text-gray-700 hover:bg-blue-300'
      }`;
    }
  };

  return (
    <nav
      className={`py-3 px-4 shadow-lg mb-6 rounded-md ${
        isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'
      }`}
    >
      <div className="flex items-center justify-start">
        {/* Back Button */}
        <button
          onClick={handleBackClick}
          className={`flex items-center ${
            isDarkMode ? 'text-blue-400' : 'text-blue-500'
          } hover:text-gray-700 transition-all duration-300`}
        >
          <AiOutlineArrowLeft size={24} />
        </button>

        {/* Navbar links */}
        <div
          className={`hidden lg:flex space-x-4 ml-4 ${
            isMobileMenuOpen ? 'hidden' : ''
          }`}
        >
          <button
            className={getButtonClasses('details')}
            onClick={() => setActiveTab('details')}
          >
            Details
          </button>
          <button
            className={getButtonClasses('folders')}
            onClick={() => setActiveTab('folders')}
          >
            Folders
          </button>
          <button
            className={getButtonClasses('files')}
            onClick={() => setActiveTab('files')}
          >
            Files
          </button>
          <button
            className={getButtonClasses('documents')}
            onClick={() => setActiveTab('documents')}
          >
            Documents
          </button>
          <button
            className={getButtonClasses('teams')}
            onClick={() => setActiveTab('teams')}
          >
            Teams
          </button>
        </div>

        {/* Mobile menu toggle */}
        <button
          className={`lg:hidden ${
            isDarkMode ? 'text-blue-400' : 'text-blue-500'
          } hover:text-gray-700`}
          onClick={handleMenuToggle}
        >
          <AiOutlineBars size={24} />
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          className={`lg:hidden flex flex-col space-y-2 mt-3 ${
            isDarkMode ? 'bg-gray-800' : 'bg-white'
          } p-4 rounded-md`}
        >
          <button
            className={getButtonClasses('details')}
            onClick={() => {
              setActiveTab('details');
              setIsMobileMenuOpen(false);
            }}
          >
            Details
          </button>
          <button
            className={getButtonClasses('folders')}
            onClick={() => {
              setActiveTab('folders');
              setIsMobileMenuOpen(false);
            }}
          >
            Folders
          </button>
          <button
            className={getButtonClasses('files')}
            onClick={() => {
              setActiveTab('files');
              setIsMobileMenuOpen(false);
            }}
          >
            Files
          </button>
          <button
            className={getButtonClasses('documents')}
            onClick={() => {
              setActiveTab('documents');
              setIsMobileMenuOpen(false);
            }}
          >
            Documents
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
